export default __webpack_public_path__ + "static/media/Face of the Moon.46c791ba.jpg";